<template>
  <div class="carousel-container">
    <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item " :class="index == 0 ? ' active ' : ''"
          v-for="(image, index) in screenWidth > 600 ? imagesDesktop : imagesMovil" :key="index">
          <img :src="getImageUrl(image)" class="imgCarrouselTerranova" alt="...">
        </div>
      </div>
      <button class="carousel-control carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    <div class="col-12 carouselTerranovaContenedor carousel-overlay-text mx-auto">
      <div class="carouselTerranova mx-auto">
        <img src="../../../public/assets/images/terranova/terranovaBanner.png" class="mx-auto" alt="...">
        <p class="titulo">Lotes residenciales</p>
        <p class=" message">Un desarrollo privado con terrenos de calidad, servicios completos y una
          ubicación privilegiada, diseñado para brindarte estabilidad y un futuro seguro.</p>
        <div class="w-full contenedorBtn">
          <div class="bb-1 w-fc mx-auto btn">
            <p class="text-uppercase font16 mt-3 cursorPointer" @click="() => $router.push('/contacto')">Contáctanos</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
  name: 'ComponenteCarrousel',
  setup() {
    const screenWidth = inject('screenWidth');
    const getImageUrl = inject('getImageUrl');

    return {
      screenWidth,
      getImageUrl
    };
  }, data() {
    return {
      imagesDesktop: [
        "assets/images/terranova/Terranova_Banner1.png",
        "assets/images/terranova/Terranova_Banner2.png",
        "assets/images/terranova/Terranova_Banner3.png",
      ],
      imagesMovil: [
        "assets/images/movil/terranova/Terranova_Banner1.png",
        "assets/images/movil/terranova/Terranova_Banner2.png",
        "assets/images/movil/terranova/Terranova_Banner3.png",
      ],
    };
  },
}
</script>